
import React, { useEffect} from 'react';
import { PROFIL } from '../../../constants/enum';
import { Checkbox } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import MyButton from '../../Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

const style = {
  row: {
    height: 'fit-content',
    alignItems: 'flex-start',
  },
  subRow: {
    display: 'flex',
    alignItems: 'center',
    width: 'auto',
    marginLeft: '20px',
  },
  subRowLabel: {
    fontSize: '18px',
    textTransform: 'uppercase',
    color: '#33a9d5',
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
};

export const StepValidationIntervenants = (props) => {
  const {
    refs,
    profil,
    handleChangeCheckBox,
    validationSaisies,
    setValidationSaisies,
    notAbleToChange,
    validSteps,
    setValidSteps,
    demandePassage,
    onNextStep
  } = props;
  const editable = validSteps.step9 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT);

  useEffect(() => {
    let allCheckboxesChecked = true;

    if (!validationSaisies.steDevis || !validationSaisies.stePreSpe|| !validationSaisies.soaDevis|| !validationSaisies.soaPreSpe)
      allCheckboxesChecked = false;

    validationSaisies.centres.map((centre) => {
      if (!centre.devis || !centre.preSpe)
        allCheckboxesChecked = false;
    });

    setValidSteps({...validSteps, step9: allCheckboxesChecked});
  }, [validationSaisies]);

  const handleChangeCheckBoxCentre = (event, i) => {
    let centres = [...validationSaisies.centres];

    centres[i][event.target.name] = event.target.checked;

    setValidationSaisies({...validationSaisies, centres: centres});
  };

  return <div ref={(divRef) => refs.current['step-validation_des_intervenants'] = divRef} className='step'>
    <div className='step-content'>
      <div className='step-content-row'>
        <h3 className='modal-step-title'>Validation des intervenants</h3>
        <div style={{
          width: "fit-content"
        }}>
          {/* region SERVICE TE */}
          <div className='row'
               style={{ flexWrap: 'nowrap', justifyContent: 'left', height: '50px' }}>
            <div className='row' style={{ ...style.row, justifyContent: 'space-between', width: '100%' }}>
              <div style={{
                ...style.subRow,
                justifyContent: 'space-between',
                width: '100%',
                marginLeft: '34px',
              }}>
                <div style={style.subRowLabel}>Service TE</div>
                <div style={style.subRow}>
                  <FormControlLabel
                    style={style.checkboxContainer}
                    control={<Checkbox name='steDevis'
                                       value={validationSaisies.steDevis || false}
                                       style={{ padding: '10px' }}
                                       onChange={(e) => handleChangeCheckBox(e, validationSaisies, setValidationSaisies)}
                                       checked={validationSaisies.steDevis === true}
                                       disabled={editable} />}
                    label='Devis' />

                  <FormControlLabel
                    style={style.checkboxContainer}
                    control={<Checkbox name='stePreSpe'
                                       value={validationSaisies.stePreSpe || false}
                                       style={{ padding: '10px' }}
                                       onChange={(e) => handleChangeCheckBox(e, validationSaisies, setValidationSaisies)}
                                       checked={validationSaisies.stePreSpe === true}
                                       disabled={editable} />}
                    label='Prescriptions Spécifiques' />
                </div>
              </div>
            </div>
          </div>
          {/* endregion */}

          {/* region SERVICE OA */}
          <div className='row'
               style={{ flexWrap: 'nowrap', justifyContent: 'left', height: '70px' }}>
            <div className='row' style={{ ...style.row, justifyContent: 'space-between', width: '100%' }}>
              <div style={{
                ...style.subRow,
                justifyContent: 'space-between',
                width: '100%',
                marginLeft: '34px',
              }}>
                <div style={style.subRowLabel}>Service OA</div>
                <div style={style.subRow}>
                  <FormControlLabel
                    style={style.checkboxContainer}
                    control={<Checkbox name='soaDevis'
                                       value={validationSaisies.soaDevis || false}
                                       style={{ padding: '10px' }}
                                       onChange={(e) => handleChangeCheckBox(e, validationSaisies, setValidationSaisies)}
                                       checked={validationSaisies.soaDevis === true}
                                       disabled={editable} />}
                    label='Devis' />

                  <FormControlLabel
                    style={style.checkboxContainer}
                    control={<Checkbox name='soaPreSpe'
                                       value={validationSaisies.soaPreSpe || false}
                                       style={{ padding: '10px' }}
                                       onChange={(e) => handleChangeCheckBox(e, validationSaisies, setValidationSaisies)}
                                       checked={validationSaisies.soaPreSpe === true}
                                       disabled={editable} />}
                    label='Prescriptions Spécifiques' />
                </div>
              </div>
            </div>
          </div>
          {/*  endregion */}

          {/* region CENTRES CONCERNES */}
          <div className='row'
               style={{ flexWrap: 'nowrap', justifyContent: 'left', height: '40px' }}>
            <div className='row' style={{ ...style.row, justifyContent: 'space-between', width: '100%' }}>
              <div style={{
                ...style.subRow,
                justifyContent: 'space-between',
                width: '40%',
                marginLeft: '34px',
              }}>
                <div style={style.subRowLabel}>Les centres concernés :</div>
                <div style={style.subRow}></div>
              </div>
            </div>
          </div>

          <div className='row'
               style={{ flexWrap: 'nowrap', justifyContent: 'left', height: 'auto' }}>
            <div className='row' style={{ ...style.row, justifyContent: 'space-between', width: '100%' }}>
              <div style={{
                ...style.subRow,
                justifyContent: 'space-between',
                width: '100%',
                marginLeft: '30px',
              }}>
                <div style={{
                  ...style.subRow,
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  width: '100%',
                }}>
                  {validationSaisies.centres.map((centre, i) =>
                    (<div style={{
                      ...style.subRow,
                      width: '100%',
                      height: '60px',
                      justifyContent: 'space-between',
                      marginLeft: '0px'
                    }}>
                      <div style={style.subRowLabel}>{centre.name} :</div>
                      <div style={style.subRow}>
                        <FormControlLabel
                          style={style.checkboxContainer}
                          control={<Checkbox name='devis'
                                             value={centre.devis || false}
                                             style={{ padding: '10px' }}
                                             onChange={(e) => handleChangeCheckBoxCentre(e, i)}
                                             checked={centre.devis === true}
                                             disabled={editable} />}
                          label='Devis' />

                        <FormControlLabel
                          style={style.checkboxContainer}
                          control={<Checkbox name='preSpe'
                                             value={centre.preSpe || false}
                                             style={{ padding: '10px' }}
                                             onChange={(e) => handleChangeCheckBoxCentre(e, i)}
                                             checked={centre.preSpe === true}
                                             disabled={editable} />}
                          label='Prescriptions Spécifiques' />
                      </div>
                    </div>))
                  }
                </div>
              </div>
            </div>
          </div>
          {/*  endregion */}
        </div>
      </div>
      {
          (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && demandePassage.id !== 0 &&
          <div className='row-without-height'
               style={{ justifyContent: 'flex-end', alignItems: 'center', height: '80px' }}>
            <MyButton
              style={validSteps['step9'] ? 'buttonRejected' : 'buttonValidation'}
              label={validSteps['step9'] ? `Rejeter l'étape` : `Valider l'étape`}
              icon={validSteps['step9'] ? faXmark : faCheck}
              onClick={() => {
                setValidSteps({...validSteps, step9: !validSteps['step9']});
              }}
            />
          </div>
        }
    </div>
  </div>;
};